export default __webpack_public_path__ + "static/media/services-bg.cc3d8804.webp";